export enum BreadcrumbEvent {
  BreadcrumbInteraction = 'breadcrumb_interaction',
}
